import React from 'react';
import PropTypes from 'prop-types';

const Disclaimer = ({ disclaimerText }) => {
    if (!disclaimerText) return null;
    return <div className="card__disclaimer">{disclaimerText}</div>;
};
Disclaimer.propTypes = {
    disclaimerText: PropTypes.string,
};
export default Disclaimer;
